














import Widget from "@/components/common/Widget.vue";
import MultiHorizontalBar from "@/components/charts/MultiHorizontalBar.vue";
import DashboardItemWrapper from "@/components/DashboardItems/DashboardItemWrapper.vue";
import Vue from "vue";

import Component from "vue-class-component";

@Component({
  components: {
    Widget,
    DashboardItemWrapper,
    MultiHorizontalBar,
  },
})
export default class Top10KostenBereiche extends Vue {
  public static id = "Top10KostenBereiche";
  public static dprops = { width: 4, height: 4, minWidth: 2, minHeight: 2 };
  get _id() {
    return Top10KostenBereiche.id;
  }
  get _dprops() {
    return Top10KostenBereiche.dprops;
  }
}
